// removed by extract-text-webpack-plugin
module.exports = {"SymbolCell":"SymbolCell","SymbolCellWatchlist":"SymbolCellWatchlist","ag-cell-value":"ag-cell-value","DiviendDate":"DiviendDate","AgCellValueWithVCSC":"AgCellValueWithVCSC","ag-icon-cross":"ag-icon-cross","ag-icon-menu":"ag-icon-menu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/StockBoard/SymbolCell/styles.scss
// module id = 2041
// module chunks = 10